import { CustomRouteService } from '../pages/custom-route/services/custom-route.service';
import { PlannerDayStateService } from '../pages/custom-route/shared/planner/services';
import { computed, inject, Injectable, signal, WritableSignal } from '@angular/core';

const MARGIN = 175;

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  public isScrolled: WritableSignal<boolean> = signal(false);

  private readonly _customRouteService = inject(CustomRouteService);
  private readonly _plannerDayStateService = inject(PlannerDayStateService);

  private readonly _customRouteData = computed(() => this._customRouteService.customRouteData());
  get dailyCustomRouteData() {
    return this._customRouteData().dailyRoutes[this._dayToShowIndex()];
  }
  get dailyCustomRouteDataDate() {
    return this.dailyCustomRouteData.date;
  }
  
  private readonly _dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());

  private _scrollTarget: HTMLElement | null = null;
  private _scrollTimeout: ReturnType<typeof setTimeout> | null = null;

  private _onScroll = () => {
    this.isScrolled.set(true);

    if (this._scrollTimeout) clearTimeout(this._scrollTimeout);

    this._scrollTimeout = setTimeout(() => {
      this.isScrolled.set(false);
    }, 300);
  };

  attachScrollListener(el: HTMLElement): void {
    if (!el) return;
    this._scrollTarget = el;
    el.addEventListener('scroll', this._onScroll, { passive: true });
  }

  detachScrollListener(): void {
    if (this._scrollTarget) {
      this._scrollTarget.removeEventListener('scroll', this._onScroll);
      this._scrollTarget = null;
    }

    if (this._scrollTimeout) {
      clearTimeout(this._scrollTimeout);
      this._scrollTimeout = null;
    }
  }
  
  autoScrollToTop = (el: HTMLElement) => {
    if (!el) return;

    setTimeout(() => {
      el.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }

  scrollToElementByTrameIndex = ( container: HTMLElement, trameIndex: number = 0 ): void => {
    const target = container.querySelector(`[data-header-point-scroll-index="${trameIndex}"]`);
    if (!target) {
      console.warn(`Element with data-header-point-scroll-index="${trameIndex}" not found.`);
      return;
    }

    const targetElement = target as HTMLElement;
    const targetTop = this.getOffsetTopRelativeToContainer(targetElement, container);
    container.scrollTo({
      top: targetTop >= (MARGIN * 2) 
        ? targetTop - MARGIN 
        : 0,
      behavior: 'smooth'
    });
  }

  private getOffsetTopRelativeToContainer = (element: HTMLElement, container: HTMLElement): number => {
    let offset = 0;
    let current: HTMLElement | null = element;
    while (current && current !== container) {
      offset += current.offsetTop;
      current = current.offsetParent as HTMLElement;
    }
    return offset;
  }
  
  scrollToElementByTimelineHour = ( container: HTMLElement, hour: number = 0 ): void => {
    const target = container.querySelector(`[data-hour="${hour}"]`);
    if (!target) {
      console.warn(`Element with data-header-point-scroll-index="${hour}" not found.`);
      return;
    }

    const targetElement = target as HTMLElement;
    const targetTop = this.getOffsetTopRelativeToContainer(targetElement, container);
    container.scrollTo({
      top: targetTop >= (MARGIN * 2) 
        ? targetTop - MARGIN 
        : 0,
      behavior: 'smooth'
    });
  }
}
